<template>
  <div>
    <div class="flex-100 px-2 mb-4 mt-2">
      <fake-input-frame :label="$t('COMPONENT_PHYSICIAN_DETAILS.IDENTIFICATION') + ' *'">
        <div class="layout layout-column mb-4">
          <div class="flex-gt-sm-50 flex-100 px-2 my-2 mb-4">
            <validation-provider tag="div"
                                 name="selectedKindOfIdentification"
                                 ref="selectedKindOfIdentification"
                                 rules="">
              <v-btn-toggle v-model="selectedKindOfIdentification"
                            dense
                            :mandatory="!!selectedKindOfIdentification"
                            class="ml-2"
                            style="margin-top:2px;"
                            :color="compColor.prime">
                <v-btn :key="index" v-for="(kind, index) in listOfIdentifikationElements" :value="kind.value"
                       @click="setKindOfIdentifikationElement(kind.value)">
                  {{ kind.text }}
                </v-btn>
              </v-btn-toggle>
            </validation-provider>
          </div>

          <!-- Identifikation Praxis -->

          <div v-if="selectedKindOfIdentification === 'clinic'" class="layout-row layout-wrap flex-100 ml-2">
            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div" name="lanr" rules="required|min:9|max:9|lanr|decimal" v-slot="{ errors }">
                <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  :label="$t('COMPONENT_PHYSICIAN_DETAILS.LANR') + ' *'"
                  outlined
                  maxLength="9"
                  counter="9"
                  :error-messages="errors[0]"
                  :hide-details="!errors || errors.length <= 0"
                  v-model="model.lanr"
                ></v-text-field>
              </validation-provider>
            </div>

            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div" name="bsnr" rules="min:9|max:9|decimal" v-slot="{ errors }">
                <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  :label="$t('COMPONENT_PHYSICIAN_DETAILS.BSNR')"
                  outlined
                  maxLength="9"
                  counter="9"
                  :error-messages="errors[0]"
                  :hide-details="!errors || errors.length <= 0"
                  v-model="model.bsnr"
                ></v-text-field>
              </validation-provider>
            </div>
          </div>

          <!-- Identifikation Krankenhaus -->

          <div v-if="selectedKindOfIdentification === 'hospital'" class="layout-row layout-wrap flex-100 ml-2">
            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div" name="iknr" rules="required|min:9|max:9|decimal" v-slot="{ errors }">
                <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  :label="$t('COMPONENT_PHYSICIAN_DETAILS.IK_NUMBER') + ' *'"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  maxLength="9"
                  :error-messages="errors[0]"
                  v-model="model.iknr"
                ></v-text-field>
              </validation-provider>
            </div>

            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div" name="hospital_department" rules="max:255|address_string" v-slot="{ errors }">
                <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  :label="$t('COMPONENT_PHYSICIAN_DETAILS.HOSPITAL_DEPARTMENT')"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  maxLength="255"
                  :error-messages="errors[0]"
                  v-model="model.hospital_department"
                ></v-text-field>
              </validation-provider>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhysicianDetails',
  props: {
    value: {
      type: Object,
      default: () => ({ })
    }
  },
  data () {
    return {
      model: {},
      selectedKindOfIdentification: null,
      listOfIdentifikationElements: [
        { value: 'clinic', text: 'Praxis'},
        { value: 'hospital', text: 'Krankenhaus'}
      ],
    }
  },
  methods: {
    /**
     * Set value selectedKindOfIdentification when triggering btn-group
     *
     * @param value The selected value
     */
    setKindOfIdentifikationElement (value) {
      // reset elements of identifications only, if new kind is selected e.g. clinic -> hospital
      if (value === 'clinic') {
        this.$delete(this.model, 'iknr')
        this.$delete(this.model, 'hospital_department')
      } else if (value === 'hospital') {
        this.$delete(this.model, 'lanr')
        this.$delete(this.model, 'bsnr')
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          // set value of radio-group of kind of identification
          this.selectedKindOfIdentification = this.model.iknr ? this.listOfIdentifikationElements[1].value : this.listOfIdentifikationElements[0].value
        }
      },
      immediate: true
    }
  }
}
</script>
